const User = () =>
  import(
    /* webpackChunkName: "system-setting-user" */ '@/pages/system/setting/user.vue'
  )


export default {
  path: 'user',
  meta: {
    label: 'users',
    auth: 'user'
  },
  component: {
    name: 'User',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemSettingUser',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: User
    }
  ]
}
